// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button {
  font-family: Roboto, 'serif';
  font-size: 1rem;
  font-weight: 500;
  border: 1px solid transparent;
  background: none;
  padding: 0 1rem;
  cursor: pointer;
  border-radius: 10rem;
  min-height: 2.45rem;
  display: inline-flex;
  vertical-align: middle;
  align-items: center;
  position: relative;
}

a.Button {
  text-decoration: inherit;
}

/* Overrides legacy bootstrap hover styles, to be removed */
.Button:hover {
  opacity: 1 !important;
  text-decoration: none;
}

.Button:hover.Button--primary {
  color: var(--palette-trovit-blue);
}

.Button:hover.Button--thribee-yellow {
  color: var(--palette-thribee-yellow);
}

.Button:hover.Button--red {
  color: var(--palette-thribee-red);
}

.Button:hover.Button--primary.Button--flat,
.Button:hover.Button--thribee-yellow.Button--flat,
.Button:hover.Button--red.Button--flat {
  color: var(--palette-thribee-white);
}

.Button::after {
  content: '';
}

.Button:hover::after {
  position: absolute;
  top: -1px;
  left: -1px;
  bottom: -1px;
  right: -1px;
  border-radius: 10rem;
}

.Button--primary {
  color: var(--palette-trovit-blue);
  border-radius: 10rem;
}

.Button--thribee-yellow {
  color: var(--palette-thribee-yellow);
  border-radius: 10rem;
}

.Button--red {
  color: var(--palette-thribee-red);
  border-radius: 10rem;
}

.Button--stroked {
  border-color: #c0c0c0;
  background-color: white;
}

.Button:hover::after,
.Button--stroked:hover::after {
  background: black;
  opacity: 0.04;
}

.Button--flat {
  color: white;
}

.Button--flat:hover::after {
  background: white;
  opacity: 0.08;
}

.Button--flat.Button--primary {
  background-color: var(--palette-trovit-blue);
}

.Button--flat.Button--thribee-yellow {
  background-color: var(--palette-thribee-yellow);
  color: #333333;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.2px;
}

.Button--flat.Button--red {
  background-color: var(--palette-thribee-red);
}

.Button--stroked.Button--primary,
.Button--flat.Button--primary {
  border-color: var(--palette-trovit-blue);
}

.Button--stroked.Button--thribee-yellow {
  border-color: var(--palette-thribee-yellow);
}

.Button--stroked.Button--red,
.Button--flat.Button--red {
  border-color: var(--palette-thribee-red);
}

.Button .SvgIcon {
  width: 1.5rem;
  margin-right: 0.6rem;
  margin-left: -0.3rem;
}

/*
 * public/includes/js/Views/Element/UI/HighChartSeriesSelector.js sets .disabled class to buttons,
 * we need to maintain this for compatibility purposes
 */
.Button.Button--disabled,
.Button.Button.disabled {
  color: var(--palette-gray-8);
  cursor: not-allowed;
}

.Button--flat.Button--disabled,
.Button--flat.disabled {
  background: var(--palette-disabled);
}

.Button--stroked.Button--disabled,
.Button--flat.Button--disabled,
.Button--stroked.disabled,
.Button--flat.disabled {
  border-color: var(--palette-disabled);
}
`, "",{"version":3,"sources":["webpack://./js/components/library/html/Button/Button.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,2DAA2D;AAC3D;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;;EAGE,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,+CAA+C;EAC/C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;;EAGE;AACF;;EAEE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;;;EAIE,qCAAqC;AACvC","sourcesContent":[".Button {\n  font-family: Roboto, 'serif';\n  font-size: 1rem;\n  font-weight: 500;\n  border: 1px solid transparent;\n  background: none;\n  padding: 0 1rem;\n  cursor: pointer;\n  border-radius: 10rem;\n  min-height: 2.45rem;\n  display: inline-flex;\n  vertical-align: middle;\n  align-items: center;\n  position: relative;\n}\n\na.Button {\n  text-decoration: inherit;\n}\n\n/* Overrides legacy bootstrap hover styles, to be removed */\n.Button:hover {\n  opacity: 1 !important;\n  text-decoration: none;\n}\n\n.Button:hover.Button--primary {\n  color: var(--palette-trovit-blue);\n}\n\n.Button:hover.Button--thribee-yellow {\n  color: var(--palette-thribee-yellow);\n}\n\n.Button:hover.Button--red {\n  color: var(--palette-thribee-red);\n}\n\n.Button:hover.Button--primary.Button--flat,\n.Button:hover.Button--thribee-yellow.Button--flat,\n.Button:hover.Button--red.Button--flat {\n  color: var(--palette-thribee-white);\n}\n\n.Button::after {\n  content: '';\n}\n\n.Button:hover::after {\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  bottom: -1px;\n  right: -1px;\n  border-radius: 10rem;\n}\n\n.Button--primary {\n  color: var(--palette-trovit-blue);\n  border-radius: 10rem;\n}\n\n.Button--thribee-yellow {\n  color: var(--palette-thribee-yellow);\n  border-radius: 10rem;\n}\n\n.Button--red {\n  color: var(--palette-thribee-red);\n  border-radius: 10rem;\n}\n\n.Button--stroked {\n  border-color: #c0c0c0;\n  background-color: white;\n}\n\n.Button:hover::after,\n.Button--stroked:hover::after {\n  background: black;\n  opacity: 0.04;\n}\n\n.Button--flat {\n  color: white;\n}\n\n.Button--flat:hover::after {\n  background: white;\n  opacity: 0.08;\n}\n\n.Button--flat.Button--primary {\n  background-color: var(--palette-trovit-blue);\n}\n\n.Button--flat.Button--thribee-yellow {\n  background-color: var(--palette-thribee-yellow);\n  color: #333333;\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 0.2px;\n}\n\n.Button--flat.Button--red {\n  background-color: var(--palette-thribee-red);\n}\n\n.Button--stroked.Button--primary,\n.Button--flat.Button--primary {\n  border-color: var(--palette-trovit-blue);\n}\n\n.Button--stroked.Button--thribee-yellow {\n  border-color: var(--palette-thribee-yellow);\n}\n\n.Button--stroked.Button--red,\n.Button--flat.Button--red {\n  border-color: var(--palette-thribee-red);\n}\n\n.Button .SvgIcon {\n  width: 1.5rem;\n  margin-right: 0.6rem;\n  margin-left: -0.3rem;\n}\n\n/*\n * public/includes/js/Views/Element/UI/HighChartSeriesSelector.js sets .disabled class to buttons,\n * we need to maintain this for compatibility purposes\n */\n.Button.Button--disabled,\n.Button.Button.disabled {\n  color: var(--palette-gray-8);\n  cursor: not-allowed;\n}\n\n.Button--flat.Button--disabled,\n.Button--flat.disabled {\n  background: var(--palette-disabled);\n}\n\n.Button--stroked.Button--disabled,\n.Button--flat.Button--disabled,\n.Button--stroked.disabled,\n.Button--flat.disabled {\n  border-color: var(--palette-disabled);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
